export default function YouAndMeTextMixin() {
    return {
        methods:{
            getFirstLetter(text){
                return text?.[0] ?? 'T'
            },
        },
        computed:{
            firstLetter(){
                return this.getFirstLetter(this.firstName)
            },
            secondLetter(){
                return this.getFirstLetter(this.secondName)
            },
        }
    }
}
